class ProfileHeaderController {
    constructor() {
        'ngInject';
    }

    selectPatient(patient) {
        var that = this;
        that.selectedPatient = patient;
    }
}

export const ProfileHeaderComponent = {
    name: 'profileHeader',
    component: {
        template: `
        <li class="dropdown patientSelect" data-uib-dropdown>
            <button class="btn btn-link navbar-btn dropdown-toggle" data-uib-dropdown-toggle>
                <span class="currentPatient">
                    <profile-icon patient="$ctrl.selectedPatient"></profile-icon>
                    <span class="patient-full-name">{{$ctrl.selectedPatient.patient | patientFullName}}</span> 
                    <span class="caret"></span>
                </span>
            </button>
            <ul class="dropdown-menu">
                <li role="presentation" data-ng-repeat="patient in $ctrl.patients track by $index">
                    <a role="menuitem" data-ng-click="$ctrl.selectPatient(patient)">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon text-success selected-patient" data-ng-show="$ctrl.selectedPatient == patient">
                            <use xlink:href="" data-ng-href="#glyphicon-ok"></use>
                        </svg>{{ patient.patient | patientFullName }}
                    </a>
                </li>
            </ul>
        </li>
        `,
        controller: ProfileHeaderController,
        bindings: {
            patients: '<',
            selectedPatient: '='
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/profileHeader.component.js